import { Aeroplanta } from "./Aeroplanta";
import { Producto } from "./Producto";

export class SalidaDetalleCombustible {
    codigoContenedor: string;
    volumen: number;
    volumen15: number;
    aforadorInicial: number;
    aforadorFinal: number;
    picoId: string;
    temperatura: number;
    densidad: number;
    producto: Producto;
    aeroplanta: Aeroplanta;
  }